import * as React from 'react';

function SvgSearchLens2(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.168 17.633a7.4 7.4 0 009.97.451l1.006 1.006-.227.228a.633.633 0 000 .895l4.602 4.602a.633.633 0 00.895 0l1.4-1.4a.633.633 0 000-.895l-4.602-4.602a.633.633 0 00-.895 0l-.278.277-1.002-1a7.4 7.4 0 10-10.87.438zM16.74 8.06a6.135 6.135 0 01-.001 8.676 6.135 6.135 0 11-8.675-8.675 6.135 6.135 0 018.676-.001zm6.226 15.412l.506-.506-3.708-3.707-.505.505 3.707 3.708z"
        fill="#414B56"
      />
    </svg>
  );
}

export default SvgSearchLens2;
